import { MainPathEnum, SubPathEnum } from '../../../../common/types/routing'
import { Insight, InsightType } from '../../../Insights/types'
import { AnalysisRoutes } from '../../../Processes/ProcessMining/Analysis/constants'

const insight_type1 = {
  id: '39ab8c4e-d16f-4265-a98f-cb4bd78f9fb6',
  label: 'Process transformation',
  color: 'indigo',
}
const insight_type2 = {
  id: '1e33a5ce-938d-44c4-a867-4333efee67fa',
  label: 'Scaling automation',
  color: 'green',
}
const insight_type3 = {
  id: '54f10fc0-f050-496d-b323-926f2c3452bc',
  label: 'Digital enablement',
  color: 'pink',
}

export const INSIGHT_TYPES: InsightType[] = [insight_type1, insight_type2, insight_type3]

export const INSIGHT_TABS = INSIGHT_TYPES.map(({ id, label }) => ({ label: label, value: id }))

const INSIGHT_DATA: Insight[] = [
  {
    id: '0b1456b1-8189-42c2-8661-0a630e92fb22',
    title: 'What are the most significant process variations?',
    description: 'Perform process conformance checks to see where and what causes the variations.',
    solution: 'Identify the root causes with the process specialists for process excellence.',
    image_url: 'images/processes_variants.png',
    image_alt: 'Screenshot of account receivables process variants',
    href: SubPathEnum.VARIANTS,
    isProcessInsight: true,
    types: [insight_type1],
  },
  {
    id: '414abb3a-c920-413e-9b3e-7642b9155f4e',
    title: 'What is "the best" process variant?',
    description: 'Pinpoint the fastest and least manual process variant.',
    solution: 'Establish new best practices in the organization.',
    image_url: 'images/processes_variants2.png',
    image_alt: 'Screenshot of account receivable process variants selector',
    href: SubPathEnum.VARIANTS,
    isProcessInsight: true,
    types: [insight_type1],
  },
  {
    id: '5126b25f-7965-4def-8093-c7d24a8441d8',
    title: 'What teams do differently?',
    description:
      'Identify the difference and best practices across teams in your organization and which tools are the most efficient ones.',
    solution: 'Deploy the tools and best practices to teams that could benefit from those.',
    image_url: 'images/business_apps_time.png',
    image_alt: 'Screenshot of business apps teams',
    href: `/${MainPathEnum.BUSINESS_APPS}/${SubPathEnum.TEAMS}`,
    types: [insight_type1, insight_type3],
  },
  {
    id: '533a4d16-93d2-4c54-ba4e-a0db329741c6',
    title: 'What are the top repetitive workflows?',
    description: 'Check which are the most repetitive workflows among teams and the whole company.',
    solution: 'RPA or other automation technology.',
    image_url: 'images/processes_task_discovery.png',
    image_alt: 'Screenshot of process discovery view',
    href: `/${MainPathEnum.PROCESSES}/${SubPathEnum.TASK_DISCOVERY}`,
    types: [insight_type1, insight_type2],
  },
  {
    id: '55235453-42b8-4edc-a0ae-eec412c92688',
    title: 'How can I find my slowest process transactions?',
    description: 'Pinpoint the transactions and variants taking the longest to process.',
    solution: 'Identify the root causes with the process specialists for process excellence.',
    image_url: 'images/processes_analysis2.png',
    image_alt: 'Screenshot of work view application flows',
    href: SubPathEnum.ANALYSIS,
    isProcessInsight: true,
    types: [insight_type1],
  },
  {
    id: '563445c6-da82-44f5-b509-b83eb3731e21',
    title: 'What is the real impact of our development activities?',
    description:
      'Track the progress of any development activity against the data. Create development subjects in any Workfellow view by clicking add a case. Connect business metrics data to cases and follow up on the development funnel and the impact of activities taken.',
    solution: 'Centralize all the development activities and prioritize based on impact.',
    image_url: 'images/cases.png',
    image_alt: 'Screenshot of cases view',
    href: `/${MainPathEnum.OPPORTUNITIES}`,
    types: [insight_type1, insight_type2, insight_type3],
  },
  {
    id: '7088471f-9766-402a-831a-b93e15a8f00b',
    title: 'How our key metrics have evolved over the past 3/6 months?',
    description:
      'Save any business process metric as a favorite to follow up on the development over time.',
    solution: 'Find out which solutions and approaches have the best impact.',
    image_url: 'images/favorites.png',
    image_alt: 'Screenshot of favorite view',
    href: `/${MainPathEnum.FAVORITES}`,
    types: [insight_type1, insight_type2, insight_type3],
  },
  {
    id: '75f8e3e1-7c50-4a28-bdf9-e34fd5206af3',
    title: 'Are there unneeded software licenses that we could save?',
    description: 'Monitor the use of all business process applications.',
    solution:
      'Check if which applications are not used, causing unnecessary license costs and process variances.',
    image_url: 'images/business_apps_time.png',
    image_alt: 'Screenshot of business apps view',
    href: `/${MainPathEnum.BUSINESS_APPS}`,
    types: [insight_type3],
  },
  {
    id: '772acb89-9b70-4e2b-8251-6990f44f2927',
    title: 'What has changed in the operations lately?',
    description:
      'Quickly check what has changed in the past weeks to identify possible process issues before those realize.',
    solution: '',
    image_url: 'images/business_apps_trends.png',
    image_alt: 'Screenshot of business apps trends view',
    href: `/${MainPathEnum.BUSINESS_APPS}/${SubPathEnum.TRENDS}`,
    types: [insight_type1],
  },
  {
    id: '7afee6c0-1d6f-4dbc-9b62-0452f2283586',
    title: 'Is the right team doing the right work?',
    description: 'Confirmation of which team is playing what part in your processes.',
    solution:
      'This is a great feature for answering the crucial question of who is doing what re. your processes.',
    image_url: 'images/teams.png',
    image_alt: 'Screenshot of business apps trends',
    href: SubPathEnum.OVERVIEW,
    isProcessInsight: true,
    types: [insight_type1, insight_type3],
  },
  {
    id: 'ba18f386-9a16-4e58-a4e1-af9aa94c8b47',
    title: 'What is the main improvement potential found for our processes?',
    description:
      'Workfellow automatically crunches the numbers for you in the process insights tab.',
    solution: 'Design automation or do development for these steps.',
    image_url: 'images/processes_insights.png',
    image_alt: 'Screenshot of processes account receivables',
    href: SubPathEnum.INSIGHTS,
    isProcessInsight: true,
    types: [insight_type1, insight_type2],
  },
  {
    id: 'c45c5fa0-40da-45e3-9f30-acd8a813da6f',
    title: 'What is our cost per transaction, and how is it developing?',
    description:
      'Track when transactions are processed on business applications and get the realized work cost for each. Follow up on the real-time data to see how development activities are improving your processes.',
    solution: 'Identify the most manual steps for automation or process development.',
    image_url: 'images/cost_per_transaction.png',
    image_alt: 'Screenshot of account receivables process',
    href: SubPathEnum.OVERVIEW,
    isProcessInsight: true,
    types: [insight_type1],
  },
  {
    id: 'fe4cf4b1-4350-49fe-8d5c-8599b2cdacb6',
    title: 'How can this be utilised for continuous improvement?',
    description:
      'A good first step is to define the problem. Then finding the most problematic transactions. Opening them and disecting the issue as a team is a common best practise.',
    solution:
      'With this understanding, one can move towards unblocking bottlenecks, automating or balancing out the work in a new way.',
    image_url: 'images/processes_analysis2.png',
    image_alt: 'Screenshot of cases view',
    href: `${SubPathEnum.ANALYSIS}/${AnalysisRoutes.TRANSACTIONS}`,
    isProcessInsight: true,
    types: [insight_type1],
  },
]

export const getInsights = (trackedProcessesIds: string[], tabSelected: string) => {
  // If no processes added for the company -> Ignore process
  // related insights as we can't navigate to them.
  if (!trackedProcessesIds.length)
    return INSIGHT_DATA.filter((insight) => !insight.isProcessInsight)

  const filteredInsights = INSIGHT_DATA.filter((insight) => {
    return insight.types.some((type) => type.id === tabSelected)
  })

  // Just use the first process id as the URL path to navigate to when the insight has process URL.
  const usedProcessId = trackedProcessesIds[0]

  // /processes/${usedProcessId}/${path}
  return filteredInsights.map((insight) => {
    const copiedInsight = { ...insight }
    if (insight.isProcessInsight) {
      copiedInsight.href = `/${MainPathEnum.PROCESSES}/${usedProcessId}/${insight.href}`
    }
    return copiedInsight
  })
}

